import React from 'react';
import { ProductViewModes } from '@/utils/productStateUtils';
import MerchProductViewTemplate from '@/components/partials/MerchProductView/MerchProductViewTemplate';
import { useMerchProductView } from '@/components/partials/MerchProductView/useMerchProductView';

interface MerchProductViewProps {
  productViewMode?: ProductViewModes;
}

export default function MerchProductView({
  productViewMode = ProductViewModes.ReadOnly,
}: MerchProductViewProps) {
  const viewHook = useMerchProductView(productViewMode);

  return (
    <MerchProductViewTemplate
      productViewMode={productViewMode}
      viewHook={viewHook}
    />
  );
}
